import React from "react";
import useAuth from "../../../hooks/useAuth";

function DashboardHome() {
  const { user } = useAuth();
  
  return (
    <div className="h-full flex flex-col items-center justify-center text-center p-8 bg-white rounded-3xl shadow-sm border border-slate-100 min-h-[60vh] mt-4">
      <div className="w-24 h-24 bg-amber-100 rounded-full flex items-center justify-center mb-6 shadow-inner">
        <span className="text-5xl">👋</span>
      </div>
      <h2 className="text-3xl font-bold text-slate-900 mb-3">
        Welcome back, {user?.displayName?.split(" ")[0] || "Friend"}!
      </h2>
      <p className="text-slate-500 max-w-md mx-auto mb-8 font-medium leading-relaxed">
        This is your central hub for managing everything. Select an option from the sidebar to view your bookings, manage products, or adjust settings.
      </p>
      
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 w-full max-w-2xl mt-4">
        <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 flex flex-col items-center justify-center">
          <span className="text-2xl mb-2">🐕</span>
          <span className="text-sm font-bold text-slate-700">Pets</span>
        </div>
        <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 flex flex-col items-center justify-center">
          <span className="text-2xl mb-2">📦</span>
          <span className="text-sm font-bold text-slate-700">Orders</span>
        </div>
        <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 flex flex-col items-center justify-center">
          <span className="text-2xl mb-2">⭐</span>
          <span className="text-sm font-bold text-slate-700">Reviews</span>
        </div>
      </div>
    </div>
  );
}

export default DashboardHome;
